import script from "./NotificationCard.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationCard.vue?vue&type=script&setup=true&lang=js"

import "./NotificationCard.vue?vue&type=style&index=0&id=2955fa83&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2955fa83"]])

export default __exports__